var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-chat-bubble_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-chat-bubble_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.033 14.585l-1.478 1.478c-.21.21-.453.26-.727.145-.273-.115-.41-.322-.41-.62V3.758c0-.375.13-.692.389-.951.259-.26.576-.389.95-.389h12.488c.375 0 .692.13.951.389.26.259.389.576.389.95v9.488c0 .375-.13.692-.389.951a1.294 1.294 0 01-.951.389H5.033zM4.585 13.5h11.66a.244.244 0 00.176-.08.244.244 0 00.08-.176V3.758a.244.244 0 00-.08-.176.245.245 0 00-.176-.08H3.758a.245.245 0 00-.176.08.245.245 0 00-.08.176v10.835L4.584 13.5z",
    fill: "#171413"
  }))));
}
export default SvgIcnChatBubble;